import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'react-bootstrap';
import './DetailsInfoCard.css';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faAngleDown from '@fortawesome/fontawesome-free-solid/faAngleDown';
import faAngleUp from '@fortawesome/fontawesome-free-solid/faAngleUp';

class DetailsInfoCard extends Component {
  static propTypes = {
    itemLines: PropTypes.arrayOf(
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.element])
      )
    ).isRequired,
    headerButtons: PropTypes.arrayOf(PropTypes.element),
  };

  constructor(props) {
    super(props);
    this.state = {
      showDetails: true,
    };
  }

  handleClickDetails = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({
      showDetails: !this.state.showDetails,
    });
  };

  render() {
    const { headerButtons } = this.props;
    return (
      <div className="details-info-card">
        <div className="details-toggle" onClick={this.handleClickDetails}>
          <div className="header-buttons">
            <span>DETAILS</span>
            {this.props.leftHeaderExtraComponents !== undefined && (
              <div className="left-header-extra">
                {this.props.leftHeaderExtraComponents.map((item, index) => {
                  return <React.Fragment key={index}> {item} </React.Fragment>;
                })}
              </div>
            )}
          </div>
          <div className="details-toggle-controls">
            {headerButtons && (
              <div className="header-buttons">
                {headerButtons.map((btn, index) => {
                  return <React.Fragment key={index}>{btn}</React.Fragment>;
                })}
              </div>
            )}
            <span className="toggle">
              <FontAwesomeIcon
                icon={this.state.showDetails ? faAngleUp : faAngleDown}
              />
            </span>
          </div>
        </div>

        <Collapse in={this.state.showDetails} className="collapse-info">
          <div className="details-info-items">
            {this.props.itemLines.map((itemLine, index) => {
              return (
                <div key={index} className="details-info-item">
                  <div className="details-info-item-content">
                    {itemLine.map((item, index) => {
                      return (
                        <div key={index} className="details-info-item-line">
                          {item}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </Collapse>
      </div>
    );
  }
}

export default DetailsInfoCard;



// WEBPACK FOOTER //
// ./src/components/shared/details/DetailsInfoCard.js